// src/components/header/navBodecom.jsx

import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { HomeOutlined, CloudSyncOutlined, TeamOutlined, BarChartOutlined, ProductOutlined, GlobalOutlined, AppstoreAddOutlined, FilePdfOutlined, LogoutOutlined, ApartmentOutlined, ShopOutlined, SolutionOutlined, ShoppingCartOutlined, LineChartOutlined, UsergroupAddOutlined, SettingOutlined, AuditOutlined, FileDoneOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { logout, fetchApplications } from '../../store/auth/authSlice';
import './NavBodecom.css';

const NavBodecom = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.auth.user);
    const isAdmin = user?.username === 'admin';
    const { applications, isAuthenticated } = useSelector(state => state.auth);

    useEffect(() => {
        if (isAuthenticated && applications.length === 0) {
            dispatch(fetchApplications());
        }
    }, [isAuthenticated, applications, dispatch]);

    const handleLogout = async () => {
        try {

            await dispatch(logout()).unwrap();
            navigate('/');
        } catch (error) {
            console.error('Error durante el logout:', error);
        }
    };

    const menuItems = [
        { path: '/inicio', icon: <HomeOutlined />, label: 'Inicio', appName: 'inicio' },
        {
            label: 'Producto 1', appName: 'producto_1',
            children: [
                { path: '/buscar-proyecto', icon: <CloudSyncOutlined />, label: 'Actualización', appName: 'buscar-proyecto' },
                { path: '/es_proyectos', icon: <ApartmentOutlined />, label: 'Estructuración', appName: 'es_proyectos' },
            ],
        },
        {
            label: 'Producto 2', appName: 'producto_2',
            children: [
                {
                    label: (
                        <span style={{ color: '#212529' }}>
                            <SettingOutlined style={{ marginRight: 6 }} />
                            Implementación
                        </span>
                    ),
                    children: [
                        { path: '/planOperativo', icon: <FontAwesomeIcon icon={faHandHoldingHeart} style={{ marginRight: 6 }} />, label: 'FAO', appName: 'planOperativo' },
                        { path: '#', icon: <TeamOutlined />, label: 'Organizaciones', appName: '', disabled: true },
                    ],
                },
            ],
        },
        {
            label: 'Producto 3', appName: 'producto_3',
            children: [
                { path: '/menu-curso-fortalecimiento', icon: <ProductOutlined />, label: 'Fort. Capacidades', appName: 'menu-curso-fortalecimiento' },
            ],
        },
        {
            label: 'Información General', appName: 'info_general',
            children: [
                {
                    label: (
                        <span style={{ color: '#212529' }}>
                            <BarChartOutlined style={{ marginRight: 8 }} />
                            Informe Participación
                        </span>
                    ),
                    children: [
                        { path: '/participantes', icon: <UsergroupAddOutlined />, label: 'Participantes', appName: 'participantes' },
                        { path: '/novedad_participante', icon: <FileDoneOutlined />, label: 'Novedades', appName: 'novedad_participante' },
                        { path: '/ecas_participante', icon: <TeamOutlined />, label: 'Ecas', appName: 'ecas_participante' },
                        { path: '/visita_participante', icon: <TeamOutlined />, label: 'Visitas', appName: 'visita_participante' },
                    ],
                },
                { path: '/organizaciones', icon: <ShopOutlined />, label: 'Organizacional', appName: 'organizaciones' },
                { path: '/acuerdos-comerciales', icon: <ShoppingCartOutlined />, label: 'Comercial', appName: 'acuerdos-comerciales' },
                { path: '/caracterizacion', icon: <SolutionOutlined />, label: 'Caracterización', appName: 'caracterizacion' },
                { path: '/sistematizacionIppta', icon: <BarChartOutlined />, label: 'IPPTA', appName: 'sistematizacionIppta' },
                { path: '/encuestaEdah', icon: <LineChartOutlined />, label: 'Encuesta EDAH', appName: 'encuesta_EDAH' },
                { path: '/enfoqueGenero', icon: <TeamOutlined />, label: 'Enfoques Diferenciales', appName: 'enfoqueGenero' },
                {
                    label: (
                        <span style={{ color: '#212529' }}>
                            <AuditOutlined style={{ marginRight: 8 }} />
                            Plan de Acción
                        </span>
                    ),
                    children: [
                        { path: '/planes-accion?tipo=1', icon: <TeamOutlined />, label: 'Ejecutados por FAO', appName: 'planes-accion-fao' },
                        { path: '/planes-accion?tipo=2', icon: <TeamOutlined />, label: 'Ejecutados por Organizaciones', appName: 'planes-accion-fao' },
                    ],
                },
            ],
        },
        {
            label: 'Seguimiento', appName: 'seguimiento',
            children: [
                { path: '/poa', icon: <AppstoreAddOutlined />, label: 'POA', appName: 'poa' },
                { path: '/reportes', icon: <FilePdfOutlined />, label: 'Informes', appName: 'reportes' },
                { path: '/informe-actas', icon: <FilePdfOutlined />, label: 'Informes Actas de Entrega', appName: 'informe-actas' },
            ],
        },
        ...(isAdmin
            ? [{
                label: 'Configuración', appName: 'app-admin',
                children: [
                    { path: '/procesar_edah_admin', icon: <AppstoreAddOutlined />, label: 'Procesar EDAH', appName: 'procesar_edah_admin' },
                    { path: '/app-slider', icon: <GlobalOutlined />, label: 'Configuración', appName: 'app-slider' },
                ],
            }]
            : []
        )
    ];

    const userApplications = applications.map(app => app.app_name);
    const renderMenuItems = (items, parentKey = '') =>
    items.map((item, index) => {
        const itemKey = `${parentKey}-${item.appName || item.path || index}`;
        if (item.children) {
            return (
                <NavDropdown
                    key={`parent-${itemKey}`}
                    title={item.label}
                    id={`dropdown-${itemKey}`}
                    className="nav-dropdown"
                >
                    {item.children.map((child, childIndex) => {
                        const childKey = `${itemKey}-${child.appName || child.path || childIndex}`;
                        if (child.children) {
                            return (
                                <NavDropdown
                                    key={`child-${childKey}`}
                                    title={child.label}
                                    id={`nested-dropdown-${childKey}`}
                                    className="nested-dropdown dropdown-menu-end"
                                >
                                    {child.children.map((nestedChild, nestedIndex) => {
                                        const nestedKey = `${childKey}-${nestedChild.appName || nestedChild.path || nestedIndex}`;
                                        return (
                                            <NavDropdown.Item
                                                key={`nested-${nestedKey}`}
                                                as={Link}
                                                to={nestedChild.path}
                                                disabled={!userApplications.includes(nestedChild.appName)}
                                                className={!userApplications.includes(nestedChild.appName) ? 'disabled-link' : ''}
                                            >
                                                {nestedChild.icon} {nestedChild.label}
                                            </NavDropdown.Item>
                                        );
                                    })}
                                </NavDropdown>
                            );
                        }
                        return (
                            <NavDropdown.Item
                                key={`child-${childKey}`}
                                as={Link}
                                to={child.path}
                                disabled={!userApplications.includes(child.appName)}
                                className={!userApplications.includes(child.appName) ? 'disabled-link' : ''}
                            >
                                {child.icon} {child.label}
                            </NavDropdown.Item>
                        );
                    })}
                </NavDropdown>
            );
        }

        return (
            <Nav.Link
                key={`link-${itemKey}`}
                as={!userApplications.includes(item.appName) || item.disabled ? 'span' : Link}
                to={!userApplications.includes(item.appName) || item.disabled ? undefined : item.path}
                className={`nav-link ${!userApplications.includes(item.appName) || item.disabled ? 'disabled-link' : ''}`}
            >
                {item.icon} {item.label}
            </Nav.Link>
        );
    });

const filterMenuItems = (items) =>
        items
            .filter(item => {
                if (item.children) {
                    const filteredChildren = filterMenuItems(item.children);
                    return filteredChildren.length > 0;
                }
                return !item.appName || userApplications.includes(item.appName);
            })
            .map(item => ({
                ...item,
                children: item.children ? filterMenuItems(item.children) : undefined
            }));

    const filteredMenuItems = filterMenuItems(menuItems);


    return (
        <Navbar bg="light" expand="lg" className="mb-4 full-width-navbar pl-5">
            <div className="container-fluid">
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        {applications.length === 0
                            ? <div>Loading applications...</div>
                            : renderMenuItems(filteredMenuItems)}
                        <Nav.Link onClick={handleLogout} className="nav-link">
                            <LogoutOutlined /> Salir
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </div>
        </Navbar>
    );
};

export default NavBodecom;
